export * from './sentExternalLaboratory.service';